document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.getElementById('carousel');
  if (!carousel) return;

  const inner = carousel.querySelector('.carousel-inner');
  const items = inner.children;
  const total = items.length;
  let index = 0, interval;

  function update() {
    inner.style.transform = `translateX(-${index * 100}%)`;
  }

  function next() {
    index = (index + 1) % total;
    update();
  }

  function prev() {
    index = (index - 1 + total) % total;
    update();
  }

  function startAuto() {
    interval = setInterval(next, 8000);
  }

  function stopAuto() {
    clearInterval(interval);
  }

  carousel.querySelector('#nextBtn').addEventListener('click', () => {
    next(); stopAuto(); startAuto();
  });
  carousel.querySelector('#prevBtn').addEventListener('click', () => {
    prev(); stopAuto(); startAuto();
  });

  update();
  startAuto();
});
